import axios from 'axios';
import { getAuthToken } from './authToken';

const Axios = axios.create();

Axios.interceptors.request.use((config) => {
  config.baseURL = process.env.API_BASE_URL;
  const token = getAuthToken();
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default Axios;
